import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/alerts')(
  {
    // Observability surface — overrides the inherited `cluster` domain from the clusters subtree.
    staticData: {
      domain: 'monitoring',
    },
    component: lazyRouteComponent(() => import('./alerts.component'), 'AlertsComponent'),
  },
);
